import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TextField,
    Typography,
} from "@mui/material";
import React, { useState } from "react";

const SuccesDialog = (props) => {
    const { handleOk, open, message } = props;


    return (
        <Dialog
            fullWidth={true}
            maxWidth={"sm"}
            open={open}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <DialogContent style={{ margin: "auto" }}>
                <Typography> {message}</Typography>
            </DialogContent>
            <DialogActions style={{ display: 'flex', justifyContent: 'center' }}>
                <Button onClick={handleOk}>
                    ok
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default SuccesDialog